import styled from 'styled-components'


export const Page = styled.div`
    background-color: var(--${(props) => props.bgcolor});
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: ${(props) => props.isPadding ? "10vmin 0px 15vmin 0px" : "0px 0px 15vmin 0px"};
  `